import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { lbToKg, kgToLb } from '../lib/utils';

/*
 * Convert weight of any unit to the selected user preference
 *
 * Usage for weight:
 *   value | weightUnit:currentUnit:format
 * Example:
 *   {{ 650.2105 | weightUnit:'lb':'1.0-2' }} => formats to: 650.21 (weight in lbs)
*/

type unit = 'lb' | 'kg';

@Pipe({ name: 'weightUnit' })
export class WeightUnitPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) { }

  public transform(weight: number, currentUnit: unit, format: string, isMetricUnit?: boolean) {
    if (weight == null && !currentUnit) return;

    if (isMetricUnit && currentUnit === 'lb') weight = lbToKg(weight);
    if (!isMetricUnit && currentUnit === 'kg') weight = kgToLb(weight);

    return this.decimalPipe.transform(weight, format);
  }
}
